import { render, staticRenderFns } from "./CuadraturaOrdenesServicio.vue?vue&type=template&id=ed7c9ff2&"
import script from "./CuadraturaOrdenesServicio.vue?vue&type=script&lang=ts&"
export * from "./CuadraturaOrdenesServicio.vue?vue&type=script&lang=ts&"
import style0 from "./CuadraturaOrdenesServicio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports